import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Chip,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  IconButton,
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableBody,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Snackbar,
} from '@mui/material';
import { ExpandMore, Visibility, Download, Description, Close, Cancel } from "@mui/icons-material";
import { useLocation, useNavigate } from 'react-router-dom';
import html2pdf from "html2pdf.js";
import PrintIcon from "@mui/icons-material/Print";

const DetallePaseSalida = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pase, areas, conductores, vehiculos, rutas } = location.state || {}; // Agregar rutas aquí

  const [adjuntos, setAdjuntos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [adjuntoActual, setAdjuntoActual] = useState(null);
  const [cargandoAdjunto, setCargandoAdjunto] = useState(false);
  const [vistaPreviaData, setVistaPreviaData] = useState(null);
  const [modalAnulacionAbierto, setModalAnulacionAbierto] = useState(false);
  const [observacionesAnulacion, setObservacionesAnulacion] = useState('');
  const [anulando, setAnulando] = useState(false);
  const [mensajeExito, setMensajeExito] = useState('');
  const [mensajeError, setMensajeError] = useState('');

  // Estados de registros de salida/entrada
  const [registroSalida, setRegistroSalida] = useState(null);
  const [registroRetorno, setRegistroRetorno] = useState(null);
  const [loadingRegistros, setLoadingRegistros] = useState(false);

  // Función para generar e imprimir el PDF
  const handleImprimirPase = () => {
    // Crear el contenido HTML para el PDF
    const contentHTML = `
      <div style="
          font-family: Arial, sans-serif;
          background: #fff;
          border-radius: 14px;
          box-shadow: 0 4px 16px #0002;
          padding: 24px 26px 16px 26px;
          width: 740px;
          margin: 0 auto;
          box-sizing: border-box;
          position: relative;
          min-width: 740px;
          max-width: 740px;
          font-size: 13.5px;
          line-height: 1.23;
          overflow: hidden;
          page-break-inside: avoid;
        ">
     
        <!-- Encabezado -->
        <div style="text-align: center; border-bottom: 2.5px solid #CDCDCD; padding-bottom: 10px; margin-bottom: 13px;">
          <div style="background: #e0f2fe; padding: 4.5px 0; font-size: 1.5em; border-radius: 4px; margin-bottom: 2.5px; font-weight: bold;">SISTEMA DE GESTIÓN DE VEHÍCULOS</div>
          <h2 style="margin: 5px 0 2px 0; font-size: 1.5em;">PASE DE SALIDA #${pase.id}</h2>
          <div style="margin-top: 3.5px; font-size: 1em; color: #333;"><strong>Fecha de emisión:</strong> ${new Date().toLocaleDateString('es-ES')}</div>
        </div>
     
        <!-- Estado del Pase -->
        <div style="text-align: center; margin-bottom: 13px;">
          <span style="display: inline-block; background: ${getColorEstadoBackground(pase.estado)}; color: ${getColorEstadoText(pase.estado)}; padding: 4px 16px; font-weight: bold; font-size: 1.3em; border-radius: 7px; border: 1px solid ${getColorEstadoBorder(pase.estado)};">
            Estado: ${traducirEstado(pase.estado)}
          </span>
        </div>
     
        <!-- Información Principal -->
        <div style="margin-bottom: 10px;">
          <div style="display: flex; align-items: center; background: #f1f5f9; border-radius: 4px 4px 0 0; padding: 5px 10px;">
            <h3 style="margin: 0; font-size: 1.3em;">📋 Información del Pase</h3>
          </div>
          <table style="width: 100%; border-collapse: collapse; font-size: 0.98em; page-break-inside: avoid;">
            <tbody>
              <tr style="background-color: #f8fafc;">
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold; width: 30%;">Área Solicitante</td>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${getNombreArea(pase.area)}</td>
              </tr>
              <tr>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Conductor</td>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${getNombreConductor(pase.conductor)}</td>
              </tr>
              <tr style="background-color: #f8fafc;">
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Vehículo</td>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${getInfoVehiculo(pase.vehiculo)}</td>
              </tr>
              <tr>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Ruta</td>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${getNombreRuta(pase.ruta)}</td>
              </tr>
              <tr style="background-color: #f8fafc;">
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Fecha Solicitud</td>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${formatFecha(pase.fecha_solicitud)}</td>
              </tr>
              <tr>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Motivo</td>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${pase.motivo}</td>
              </tr>
              <tr>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Tipo de Traslado</td>
                <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${pase.tipo_traslado || 'N/A'}</td>
              </tr>
            </tbody>
          </table>
        </div>
     
        <!-- Registro de Salida -->
        ${registroSalida ? `
          <div style="margin-bottom: 10px;">
            <div style="display: flex; align-items: center; background: #e8f5e8; border-radius: 4px 4px 0 0; padding: 5px 10px;">
              <h3 style="margin: 0; font-size: 1.3em;">🚗 Registro de Salida</h3>
            </div>
            <table style="width: 100%; border-collapse: collapse; font-size: 0.98em;">
              <tbody>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold; width: 30%;">Fecha/Hora Salida</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${formatFecha(registroSalida.hora_salida)}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Kilometraje Inicial</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroSalida.kilometraje_inicio} km</td>
                </tr>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Guardia de Salida</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroSalida.nombre_guardia || 'N/A'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ` : ''}
     
        <!-- Checklist de Seguridad - Salida -->
        ${registroSalida ? `
          <div style="margin-bottom: 10px;">
            <div style="display: flex; align-items: center; background: #fff3cd; border-radius: 4px 4px 0 0; padding: 5px 10px;">
              <h3 style="margin: 0; font-size: 1.3em;">🔍 Checklist de Seguridad - Salida</h3>
            </div>
            <table style="width: 100%; border-collapse: collapse; font-size: 0.98em;">
              <tbody>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold; width: 30%;">Llanta de repuesto</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroSalida.llanta ? '✅ Sí' : '❌ No'}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Gato (Jack)</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroSalida.jack ? '✅ Sí' : '❌ No'}</td>
                </tr>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Llave de ruedas</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroSalida.llave ? '✅ Sí' : '❌ No'}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Triángulos de seguridad</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroSalida.triangulos ? '✅ Sí' : '❌ No'}</td>
                </tr>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Extintor</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroSalida.extintor ? '✅ Sí' : '❌ No'}</td>
                </tr>
              </tbody>
            </table>
            ${registroSalida.observaciones_salida ? `
              <div style="padding: 8px 12px; background: #f9fafb; border: 1px solid #e5e7eb; border-top: none;">
                <strong>Observaciones de salida:</strong> ${registroSalida.observaciones_salida}
              </div>
            ` : ''}
          </div>
        ` : ''}
     
        <!-- Registro de Retorno -->
        ${registroRetorno ? `
          <div style="margin-bottom: 10px;">
            <div style="display: flex; align-items: center; background: #e8f5e8; border-radius: 4px 4px 0 0; padding: 5px 10px;">
              <h3 style="margin: 0; font-size: 1.3em;">🏠 Registro de Retorno</h3>
            </div>
            <table style="width: 100%; border-collapse: collapse; font-size: 0.98em;">
              <tbody>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold; width: 30%;">Fecha/Hora Retorno</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${formatFecha(registroRetorno.hora_retorno)}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Kilometraje Final</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroRetorno.kilometraje_fin} km</td>
                </tr>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Guardia de Retorno</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroRetorno.nombre_guardia || 'N/A'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ` : ''}
     
        <!-- Checklist de Seguridad - Retorno -->
        ${registroRetorno ? `
          <div style="margin-bottom: 10px;">
            <div style="display: flex; align-items: center; background: #fff3cd; border-radius: 4px 4px 0 0; padding: 5px 10px;">
              <h3 style="margin: 0; font-size: 1.3em;">🔍 Checklist de Seguridad - Retorno</h3>
            </div>
            <table style="width: 100%; border-collapse: collapse; font-size: 0.98em;">
              <tbody>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold; width: 30%;">Llanta de repuesto</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroRetorno.llanta ? '✅ Sí' : '❌ No'}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Gato (Jack)</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroRetorno.jack ? '✅ Sí' : '❌ No'}</td>
                </tr>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Llave de ruedas</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroRetorno.llave ? '✅ Sí' : '❌ No'}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Triángulos de seguridad</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroRetorno.triangulos ? '✅ Sí' : '❌ No'}</td>
                </tr>
                <tr style="background-color: #f8fafc;">
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px; font-weight: bold;">Extintor</td>
                  <td style="border: 1px solid #cbd5e1; padding: 6px 4px;">${registroRetorno.extintor ? '✅ Sí' : '❌ No'}</td>
                </tr>
              </tbody>
            </table>
            ${registroRetorno.observaciones_retorno ? `
              <div style="padding: 8px 12px; background: #f9fafb; border: 1px solid #e5e7eb; border-top: none;">
                <strong>Observaciones de retorno:</strong> ${registroRetorno.observaciones_retorno}
              </div>
            ` : ''}
          </div>
        ` : ''}
     
        <!-- Observaciones Finales -->
        ${pase.observaciones_finales ? `
          <div style="margin-bottom: 10px;">
            <div style="display: flex; align-items: center; background: #ffeaa7; border-radius: 4px 4px 0 0; padding: 5px 10px;">
              <h3 style="margin: 0; font-size: 1.3em;">📝 Observaciones Finales</h3>
            </div>
            <div style="padding: 8px 12px; background: #f9fafb; border: 1px solid #e5e7eb; border-top: none;">
              ${pase.observaciones_finales}
            </div>
          </div>
        ` : ''}
     
        <!-- Pie de página -->
        <div style="text-align: center; font-size: 0.92em; color: #64748b; margin-top: 20px; padding-top: 10px; border-top: 1px solid #e2e8f0;">
          <div>Documento generado automáticamente el ${new Date().toLocaleDateString('es-ES', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })}</div>
          <div style="margin-top: 5px;">Sistema de Gestión de Vehículos - Versión 1.0</div>
        </div>
      </div>
    `;

    const element = document.createElement('div');
    element.innerHTML = contentHTML;

    const options = {
      margin: 0.5,
      filename: `Pase_Salida_${pase.id}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { 
        scale: 2,
        useCORS: true,
        logging: false
      },
      jsPDF: { 
        unit: 'in', 
        format: 'letter', 
        orientation: 'portrait' 
      }
    };

    html2pdf().set(options).from(element).save();
  };

   // Funciones auxiliares para colores del PDF
  const getColorEstadoBackground = (estado) => {
    switch (estado) {
      case 'abierto': return '#fff3cd';
      case 'anulado': return '#f8d7da';
      case 'en_ruta': return '#cce5ff';
      case 'completado': return '#d4edda';
      default: return '#e2e8f0';
    }
  };

  const getColorEstadoText = (estado) => {
    switch (estado) {
      case 'abierto': return '#856404';
      case 'anulado': return '#721c24';
      case 'en_ruta': return '#004085';
      case 'completado': return '#155724';
      default: return '#2d3748';
    }
  };

  const getColorEstadoBorder = (estado) => {
    switch (estado) {
      case 'abierto': return '#ffeaa7';
      case 'anulado': return '#f5c6cb';
      case 'en_ruta': return '#b3d7ff';
      case 'completado': return '#c3e6cb';
      default: return '#cbd5e0';
    }
  };

  // Cargar adjuntos desde API
  useEffect(() => {
    const fetchAdjuntos = async () => {
      try {
        setLoading(true);
        const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/pases/${pase.id}/listar_adjuntos/`);
        if (!response.ok) throw new Error("Error al cargar adjuntos");
        const data = await response.json();
        setAdjuntos(data);
        setError(null);
      } catch (error) {
        console.error("Error:", error);
        setError("No se pudieron cargar los adjuntos");
      } finally {
        setLoading(false);
      }
    };

    if (pase?.id) {
      fetchAdjuntos();
    }
  }, [pase]);

  // Cargar registros de salida y retorno
  useEffect(() => {
    const fetchRegistros = async () => {
      if (!pase?.id) return;
      
      try {
        setLoadingRegistros(true);
        
        // Obtener registro de salida
        const responseSalida = await fetch(`https://bei360.injupemp.gob.hn:8444/api/registro-inicio/?pase=${pase.id}`);
        if (responseSalida.ok) {
          const dataSalida = await responseSalida.json();
          // La API devuelve un array, tomamos el primer elemento si existe
          setRegistroSalida(dataSalida.length > 0 ? dataSalida[0] : null);
        }

        // Obtener registro de retorno
        const responseRetorno = await fetch(`https://bei360.injupemp.gob.hn:8444/api/registro-fin/?pase=${pase.id}`);
        if (responseRetorno.ok) {
          const dataRetorno = await responseRetorno.json();
          // La API devuelve un array, tomamos el primer elemento si existe
          setRegistroRetorno(dataRetorno.length > 0 ? dataRetorno[0] : null);
        }
      } catch (error) {
        console.error("Error al cargar registros:", error);
      } finally {
        setLoadingRegistros(false);
      }
    };

    if (pase?.id) {
      fetchRegistros();
    }
  }, [pase]);

  // Función para abrir modal de vista previa
  const handleAbrirModal = async (adjuntoId) => {
    try {
      setCargandoAdjunto(true);
      const adjunto = adjuntos.find(a => a.id === adjuntoId);
      setAdjuntoActual(adjunto);
      
      // Llamar al endpoint de vista previa
      const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/pases/${pase.id}/vista_previa_adjunto/${adjuntoId}/`);
      
      if (!response.ok) throw new Error("Error al cargar la vista previa");
      
      const data = await response.json();
      setVistaPreviaData(data);
      setModalAbierto(true);
    } catch (error) {
      console.error("Error al preparar vista previa:", error);
      alert("Error al cargar la vista previa");
    } finally {
      setCargandoAdjunto(false);
    }
  };

  // Función para cerrar modal
  const handleCerrarModal = () => {
    setModalAbierto(false);
    setAdjuntoActual(null);
    setVistaPreviaData(null);
  };

  // Función para descargar
  const handleDescargarAdjunto = async (adjuntoId, nombreArchivo) => {
    try {
      const url = `https://bei360.injupemp.gob.hn:8444/api/pases/${pase.id}/descargar_adjunto/${adjuntoId}/`;
      
      const response = await fetch(url);
      
      if (!response.ok) throw new Error("Error al descargar archivo");

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = nombreArchivo || `documento_${adjuntoId}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error al descargar:", error);
      alert("Error al descargar el archivo");
    }
  };

  // Función para anular el pase
  const handleAnularPase = async () => {
    try {
      setAnulando(true);
      setMensajeError('');
      
      const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/pases/${pase.id}/anular/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          observaciones_finales: observacionesAnulacion
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Error al anular el pase');
      }

      const data = await response.json();
      setMensajeExito(data.status || 'Pase anulado correctamente');
      
      // Cerrar modal y resetear estado
      setModalAnulacionAbierto(false);
      setObservacionesAnulacion('');
      
      // Recargar la página para actualizar el estado
      setTimeout(() => {
        window.location.reload();
      }, 1500);

    } catch (error) {
      console.error('Error al anular pase:', error);
      setMensajeError(error.message);
    } finally {
      setAnulando(false);
    }
  };

  // Función para obtener nombre de la ruta
  const getNombreRuta = (rutaId) => {
    if (!rutas || !rutaId) return 'N/A';
    const ruta = rutas.find(r => r.id === rutaId);
    return ruta ? ruta.nombre : 'N/A';
  };

  // Función para obtener nombre del área
  const getNombreArea = (areaId) => {
    if (!areas || !areaId) return 'N/A';
    const area = areas.find(a => a.id === areaId);
    return area ? area.nombre : 'N/A';
  };

  // Función para obtener nombre del conductor
  const getNombreConductor = (conductorId) => {
    if (!conductores || !conductorId) return 'N/A';
    const conductor = conductores.find(c => c.id === conductorId);
    return conductor ? `${conductor.nombre} ${conductor.apellido}` : 'N/A';
  };

  // Función para obtener información del vehículo
  const getInfoVehiculo = (vehiculoId) => {
    if (!vehiculos || !vehiculoId) return 'N/A';
    const vehiculo = vehiculos.find(v => v.id === vehiculoId);
    return vehiculo ? `(${vehiculo.marca} ${vehiculo.modelo} ${vehiculo.color})` : 'N/A';
  };

  // Formatear fecha
  const formatFecha = (fecha) => {
    if (!fecha) return 'N/A';
    return new Date(fecha).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Obtener color según estado
  const getColorEstado = (estado) => {
    switch (estado) {
      case 'abierto': return 'warning';
      case 'anulado': return 'error';
      case 'en_ruta': return 'primary';
      case 'completado': return 'success';
      default: return 'default';
    }
  };

  // Traducir estado
  const traducirEstado = (estado) => {
    const estados = {
      'abierto': 'Abierto',
      'anulado': 'Anulado',
      'en_ruta': 'En Ruta',
      'completado': 'Completado',
    };
    return estados[estado] || estado;
  };

  // Función para renderizar la vista previa según el tipo de archivo
  const renderVistaPrevia = () => {
    if (!vistaPreviaData) return null;
    
    const { tipo, base64, nombre } = vistaPreviaData;
    
    if (tipo.includes('pdf')) {
      // Para PDFs, usar data URI
      const dataUri = `data:application/pdf;base64,${base64}`;
      return (
        <iframe
          src={dataUri}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          title={`Vista previa de ${nombre}`}
        />
      );
    } else if (tipo.includes('image')) {
      // Para imágenes
      const dataUri = `data:${tipo};base64,${base64}`;
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <img 
            src={dataUri} 
            alt={nombre} 
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} 
          />
        </Box>
      );
    } else {
      // Para otros tipos de archivo, mostrar un mensaje
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column' }}>
          <Description sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            Vista previa no disponible
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Este tipo de archivo no puede mostrarse en vista previa
          </Typography>
        </Box>
      );
    }
  };

  if (!pase) {
    return (
      <Container maxWidth="md" style={{ marginTop: '2rem' }}>
        <Alert severity="error">No se encontró información del pase de salida</Alert>
      </Container>
    );
  }
  return (
    <>
      <Container maxWidth="md" style={{ marginTop: '2rem', padding: '1rem', borderRadius: '8px' }}>
        <Paper elevation={3} style={{ padding: '1rem', backgroundColor: '#f0f0f0', marginBottom: '2rem' }}>
          <Typography variant="h5" gutterBottom sx={{ textAlign: 'center', fontWeight: 'bold' }}>
            Detalles del Pase de Salida #{pase.id}
          </Typography>

          <TableContainer component={Paper} sx={{ maxWidth: 750, margin: '0 auto', mb: 3 }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', width: '40%', borderRight: '1px solid #e0e0e0' }}>
                    Área Solicitante:
                  </TableCell>
                  <TableCell>{getNombreArea(pase.area)}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                    Creado por:
                  </TableCell>
                  <TableCell>{pase.usuario_nombre}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                    Conductor:
                  </TableCell>
                  <TableCell>{getNombreConductor(pase.conductor)}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                    Vehículo:
                  </TableCell>
                  <TableCell>{getInfoVehiculo(pase.vehiculo)}</TableCell>
                </TableRow>

                
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                    Rutas:
                  </TableCell>
                  <TableCell>{getNombreRuta(pase.ruta)}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                    Fecha Solicitud:
                  </TableCell>
                  <TableCell>{formatFecha(pase.fecha_solicitud)}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                    Motivo:
                  </TableCell>
                  <TableCell>{pase.motivo}</TableCell>
                </TableRow>

                {/* Hora de Salida */}
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                    Fecha de Salida:
                  </TableCell>
                  <TableCell>
                    {loadingRegistros ? (
                      <CircularProgress size={16} />
                    ) : registroSalida ? (
                      formatFecha(registroSalida.hora_salida)
                    ) : (
                      'No registrada'
                    )}
                  </TableCell>
                </TableRow>

                {/* Kilometraje Inicial */}
                {registroSalida?.kilometraje_inicio && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                      Kilometraje Inicial:
                    </TableCell>
                    <TableCell>{registroSalida.kilometraje_inicio} km</TableCell>
                  </TableRow>
                )}

                  {/* Checklist de Seguridad - Salida */}
                    {registroSalida && (
                      <TableRow>
                        <TableCell colSpan={2} sx={{ padding: 0 }}>
                          <Accordion
                            elevation={0}
                            sx={{
                              '&:before': { display: 'none' },
                              backgroundColor: 'transparent'
                            }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMore />}
                              sx={{
                                backgroundColor: '#f5f5f5',
                                borderTop: '1px solid #e0e0e0',
                                minHeight: '48px !important',
                                '& .MuiAccordionSummary-content': { margin: '12px 0' },
                              }}
                            >
                              <Typography sx={{ fontWeight: 'bold' }}>
                                Checklist de Seguridad (Salida)
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ padding: 0, backgroundColor: '#fafafa', borderTop: '1px solid #e0e0e0' }}>
                              <Table size="small">
                                <TableBody>
                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Llanta:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroSalida.llanta ? "Sí" : "No"}
                                        color={registroSalida.llanta ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Jack:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroSalida.jack ? "Sí" : "No"}
                                        color={registroSalida.jack ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Llave:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroSalida.llave ? "Sí" : "No"}
                                        color={registroSalida.llave ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Triángulos:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroSalida.triangulos ? "Sí" : "No"}
                                        color={registroSalida.triangulos ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Extintor:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroSalida.extintor ? "Sí" : "No"}
                                        color={registroSalida.extintor ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </AccordionDetails>
                          </Accordion>
                        </TableCell>
                      </TableRow>
                    )}

                  {registroSalida?.nombre_guardia && (
                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                          Registro Salida:
                        </TableCell>
                        <TableCell>{registroSalida.nombre_guardia}</TableCell>
                      </TableRow>
                    )}
                {/* Observaciones de Salida */}
                {registroSalida?.observaciones_salida && registroSalida.checklist_seguridad !== 'incompleto' && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                      Observaciones de Salida:
                    </TableCell>
                    <TableCell>{registroSalida.observaciones_salida}</TableCell>
                  </TableRow>
                )}

                {/* Hora de Retorno */}
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                    Fecha de Retorno:
                  </TableCell>
                  <TableCell>
                    {loadingRegistros ? (
                      <CircularProgress size={16} />
                    ) : registroRetorno ? (
                      formatFecha(registroRetorno.hora_retorno)
                    ) : (
                      'No registrada'
                    )}
                  </TableCell>
                </TableRow>

                {/* Kilometraje Final */}
                {registroRetorno?.kilometraje_fin && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                      Kilometraje Final:
                    </TableCell>
                    <TableCell>{registroRetorno.kilometraje_fin} km</TableCell>
                  </TableRow>
                )}

              {/* Registro entrada */}
                {registroRetorno?.nombre_guardia && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                      Registro Entrada:
                    </TableCell>
                    <TableCell>{registroRetorno.nombre_guardia}</TableCell>
                  </TableRow>
                )}

                {/* Checklist de Seguridad - Retorno */}
                    {registroRetorno && (
                      <TableRow>
                        <TableCell colSpan={2} sx={{ padding: 0 }}>
                          <Accordion
                            elevation={0}
                            sx={{
                              '&:before': { display: 'none' },
                              backgroundColor: 'transparent'
                            }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMore />}
                              sx={{
                                backgroundColor: '#f5f5f5',
                                borderTop: '1px solid #e0e0e0',
                                minHeight: '48px !important',
                                '& .MuiAccordionSummary-content': { margin: '12px 0' },
                              }}
                            >
                              <Typography sx={{ fontWeight: 'bold' }}>
                                Checklist de Seguridad (Retorno)
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ padding: 0, backgroundColor: '#fafafa', borderTop: '1px solid #e0e0e0' }}>
                              <Table size="small">
                                <TableBody>
                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Llanta:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroRetorno.llanta ? "Sí" : "No"}
                                        color={registroRetorno.llanta ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Jack:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroRetorno.jack ? "Sí" : "No"}
                                        color={registroRetorno.jack ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Llave:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroRetorno.llave ? "Sí" : "No"}
                                        color={registroRetorno.llave ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Triángulos:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroRetorno.triangulos ? "Sí" : "No"}
                                        color={registroRetorno.triangulos ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                      Extintor:
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={registroRetorno.extintor ? "Sí" : "No"}
                                        color={registroRetorno.extintor ? "success" : "error"}
                                        size="small"
                                      />
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </AccordionDetails>
                          </Accordion>
                        </TableCell>
                      </TableRow>
                    )}

                {/* Observaciones de Retorno */}
                {registroRetorno?.observaciones_retorno && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                      Observaciones de Retorno:
                    </TableCell>
                    <TableCell>{registroRetorno.observaciones_retorno}</TableCell>
                  </TableRow>
                )}

                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                    Estado:
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip label={traducirEstado(pase.estado)} color={getColorEstado(pase.estado)} size="medium" />
                    </Box>
                  </TableCell>
                </TableRow>

                {pase.observaciones_finales && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                      Observaciones Finales:
                    </TableCell>
                    <TableCell>{pase.observaciones_finales}</TableCell>
                  </TableRow>
                )}

                {/* Accordion de Adjuntos */}
                <TableRow>
                  <TableCell colSpan={2} sx={{ padding: 0 }}>
                    <Accordion elevation={0} sx={{ '&:before': { display: 'none' }, backgroundColor: 'transparent' }}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderTop: '1px solid #e0e0e0',
                          minHeight: '48px !important',
                          '& .MuiAccordionSummary-content': { margin: '12px 0' },
                        }}
                      >
                        <Typography sx={{ fontWeight: 'bold' }}>
                          Documentos adjuntos ({adjuntos?.length || 0})
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{ padding: 0, backgroundColor: '#fafafa', borderTop: '1px solid #e0e0e0' }}>
                        <Box sx={{ p: 2 }}>
                          {loading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                              <CircularProgress size={24} />
                            </Box>
                          ) : error ? (
                            <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                          ) : adjuntos && adjuntos.length > 0 ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, maxHeight: '300px', overflowY: 'auto' }}>
                              {adjuntos.map((adjunto) => (
                                <Paper
                                  key={adjunto.id}
                                  elevation={0}
                                  sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1, '&:hover': { backgroundColor: '#f5f5f5' } }}
                                >
                                  <Description fontSize="small" color="action" />
                                  <Typography variant="body2" sx={{ flexGrow: 1 }}>
                                    {adjunto.nombre_archivo || `Documento ${adjunto.id}`}
                                  </Typography>
                                  <Tooltip title="Vista previa">
                                    <IconButton size="small" onClick={() => handleAbrirModal(adjunto.id)}>
                                      <Visibility fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Descargar">
                                    <IconButton size="small" onClick={() => handleDescargarAdjunto(adjunto.id, adjunto.nombre_archivo)}>
                                      <Download fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Paper>
                              ))}
                            </Box>
                          ) : (
                            <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', py: 2 }}>
                              No hay documentos adjuntos
                            </Typography>
                          )}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
            {/* Botón de imprimir - visible para todos los estados */}
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<PrintIcon />}
              onClick={handleImprimirPase}
              sx={{mb: 2}}
            >
              Imprimir Pase
            </Button>
            </Box>
          
          {/* Botón de anular - solo visible cuando el estado es 'abierto' */}
          {pase.estado === 'abierto' && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                color="error"
                size="small"
                startIcon={<Cancel />}
                onClick={() => setModalAnulacionAbierto(true)}
              >
                Anular Pase
              </Button>
            </Box>
            
          )}
        </Paper>
      </Container>

      {/* Modal para vista previa */}
      <Dialog
        open={modalAbierto}
        onClose={handleCerrarModal}
        maxWidth="lg"
        fullWidth
        sx={{ '& .MuiDialog-paper': { height: '80vh' } }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">
            {adjuntoActual?.nombre_archivo || 'Vista previa del documento'}
          </Typography>
          <IconButton onClick={handleCerrarModal}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
          {cargandoAdjunto ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CircularProgress />
            </Box>
          ) : (
            renderVistaPrevia()
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleCerrarModal}
            color="error"
          >
            Cerrar
          </Button>
          <Button 
            onClick={() => handleDescargarAdjunto(adjuntoActual?.id, adjuntoActual?.nombre_archivo)}
            color="primary"
            variant="contained"
            startIcon={<Download />}
          >
            Descargar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal para confirmar anulación */}
      <Dialog
        open={modalAnulacionAbierto}
        onClose={() => !anulando && setModalAnulacionAbierto(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Cancel color="error" />
            Confirmar Anulación del Pase
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ¿Está seguro que desea anular este pase de salida? Esta acción no se puede deshacer.
          </Typography>
          
          <TextField
            label="Motivo de la anulación"
            multiline
            rows={3}
            fullWidth
            value={observacionesAnulacion}
            onChange={(e) => setObservacionesAnulacion(e.target.value)}
            placeholder="Ingrese el motivo de la anulación..."
            variant="outlined"
          />
          
          {mensajeError && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {mensajeError}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setModalAnulacionAbierto(false)}
            disabled={anulando}
            color="inherit"
          >
            Cancelar
          </Button>
          <Button 
            onClick={handleAnularPase}
            disabled={anulando || !observacionesAnulacion.trim()}
            color="error"
            variant="contained"
            startIcon={anulando ? <CircularProgress size={16} /> : <Cancel />}
          >
            {anulando ? 'Anulando...' : 'Confirmar Anulación'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar para mensajes de éxito */}
      <Snackbar
        open={!!mensajeExito}
        autoHideDuration={4000}
        onClose={() => setMensajeExito('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setMensajeExito('')} 
          severity="success" 
          sx={{ width: '100%' }}
        >
          {mensajeExito}
        </Alert>
      </Snackbar>

      {/* Snackbar para mensajes de error */}
      <Snackbar
        open={!!mensajeError}
        autoHideDuration={6000}
        onClose={() => setMensajeError('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setMensajeError('')} 
          severity="error" 
          sx={{ width: '100%' }}
        >
          {mensajeError}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DetallePaseSalida;